import React from 'react'
import image1 from '../assets/images/companyLogo2.png'
import image2 from '../assets/images/pattern.png'
import '../assets/css/footer.css'

export default function Footer() {
  return (
    <div className='FooterDown'>
    <div className='container-fluid text-center' style={{position: 'relative', height: '70vh', overflow: 'hidden'}}>
      <img src={image2} alt='imageFooter'/>
        <div className='container mainContent'>
            <div className='image-container doNothing'>
                <img src={image1} alt='imageFooter2'/>
            </div>
            <div className='footerCaption'>
            Theme especially made for cooking experts, novices & all who enjoy sharing their recipes.
            </div>
            <div className='footerLinks'>
              <span>
                <a href="https://github.com/vishal257" target='_blank' rel="noreferrer">gi</a>—
                <a href="https://www.instagram.com/vishal.webengg/" target='_blank' rel="noreferrer">ig</a>—
                <a href="https://www.linkedin.com/in/vishal-4a3724289" target='_blank' rel="noreferrer">in</a>—
                <a href="https://twitter.com/Vishal_webengg" target='_blank' rel="noreferrer">tw</a>
              </span>
            </div>
            <div className='credits'>
              <div>Explore More From <span>Vishal</span></div>
              <div className='bioProject'>
                <a href='https://vishal257.github.io/portfolio/index.html' rel="noreferrer" target='_blank'>About me.<span><i className="fa-solid fa-location-arrow"></i></span>
                </a></div>
            </div>
        </div>
        <hr className='hrPadding'/>
        <div className='endFooter'>
          <div>
              Privacy Policy
          </div>
          <div>
            © 2023 Vishal, All Rights Reserved.
          </div>
        </div>
    </div>
    </div>
  )
}
